import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const UPDATE_LOGGED_IN_USER = gql`
  mutation updateLoggedInUser($data: UpdateLoggedInUserInput!) {
    updateLoggedInUser(data: $data) {
      status
      message
    }
  }
`;

export const UPDATE_TENANT_LOGO = gql`
  mutation updateTenantLogo($logo: String) {
    updateTenantLogo(logo: $logo) {
      status
      message
    }
  }
`;

export const SEND_VERIFICATION_LINK = gql`
  mutation SendVerificationLink($where: UserIdInput!) {
    sendVerificationLink(where: $where) {
      status
      message
    }
  }
`;

export const VERIFY_EMAIL = gql`
  mutation VerifyEmail($where: VerifyEmailInput!) {
    verifyEmail(where: $where) {
      status
      message
    }
  }
`;

export const VERIFY_PHONE_NO = gql`
  mutation VerifyPhoneNo($where: VerifyPhoneNoInput!) {
    verifyPhoneNo(where: $where) {
      status
      message
    }
  }
`;
